import { Component, OnInit } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { PayoutReport, Store, AppState } from '../../../../store';

@Component({
  selector: 'app-payout-report',
  templateUrl: './payout-report.component.html',
  styleUrls: ['./payout-report.component.css']
})
export class PayoutReportComponent extends ReportBase implements OnInit {

  report: PayoutReport;
  controls = [
    { name: 'id', type: 'text', title: 'PAYMENTS' },
    { name: 'created', type: 'date', title: 'DATE' },
    { name: 'status', type: 'text', title: 'Status' },
    { name: 'description', type: 'text', title: 'Description' },
    { name: 'amount', type: 'number', title: 'AMOUNT' },
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getPayoutReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/payout-report/payout-report.component.ts